import { createContext } from 'react'
import type { IWebTelemetryService } from '@ztechapps/common.contract'

/**
 * React Context for WebTelemetryService
 */
export const TelemetryContext = createContext<IWebTelemetryService | null>(null)

TelemetryContext.displayName = 'TelemetryContext'
